/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { getHealth } from '../fn/health/get-health';
import { GetHealth$Params } from '../fn/health/get-health';


/**
 * Controller used for health checks to verify if the API is responsive.
 */
@Injectable({ providedIn: 'root' })
export class HealthService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getHealth()` */
  static readonly GetHealthPath = '/health';

  /**
   * /health - GET.
   *
   * /health - GET
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getHealth()` instead.
   *
   * This method doesn't expect any request body.
   */
  getHealth$Response(params?: GetHealth$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return getHealth(this.http, this.rootUrl, params, context);
  }

  /**
   * /health - GET.
   *
   * /health - GET
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getHealth$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getHealth(params?: GetHealth$Params, context?: HttpContext): Observable<void> {
    return this.getHealth$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
